import { COUNTRIES as SHARED_COUNTRIES } from '@klareospace/pharos-lib-utils';

/** Web-app country option list, derived from the shared alpha-3 code/name map in `pharos-lib-utils`. */
export const COUNTRY_OPTIONS = SHARED_COUNTRIES.map((c) => ({ code: c.code, label: c.name }));
